export const MasterKey = "0RYd3LonA8zGI3VbVXCO2cTk1vm4dW7u";
export const token = localStorage.getItem("token");
// export const MICRO_AUTH_URL = "https://atlantis-auth.herokuapp.com";
// export const AUTH_URL = "https://atlantis-mlm.herokuapp.com/";
// export const SITE_URL = "https://atlantis-mlm.herokuapp.com/";
// export const CHAT_URL = "https://atlantis-chat.herokuapp.com/";
// export const MICRO_AUTH_URL = "https://atlantis-auth.liara.run/";
// export const AUTH_URL = "https://atlantis-mlm.liara.run/";
// export const SITE_URL = "https://atlantis-mlm.liara.run/";
// export const CHAT_URL = "https://atlantis-chat.liara.run/";

export const MICRO_AUTH_URL = "https://auth.atldmo.ir/";
export const AUTH_URL = "https://mlmapi.atldmo.ir/";
export const SITE_URL = "https://mlmapi.atldmo.ir/";
export const CHAT_URL = "https://chat.atldmo.ir/";

export const TYPES = [
  { name: "Text", value: "Text", type: "text" },
  { name: "Text Area", value: "Textarea", type: "textarea" },
  { name: "Check Box", value: "Checkbox", type: "checkbox" }
];
export const PaymentStatus = ["Paid", "Unpaid", "Failed"];
export const optionsrtl = {
  filterType: "dropdown",
  selectableRows: "none",
  download: false,
  print: false,
  // filter: false,
  // viewColumns: false,
  textLabels: {
    body: {
      noMatch: "متاسفانه هیچ رکوردی یافت نشد!",
      toolTip: "مرتب کردن"
    },
    pagination: {
      next: "بعدی",
      previous: "قبلی",
      rowsPerPage: "ردیف در هر صفحه:",
      displayRows: "از"
    },
    toolbar: {
      search: "جستجو",
      downloadCsv: "دانلود فایل اکسل",
      print: "چاپ",
      viewColumns: "نمایش ستون‌ها",
      filterTable: "فیلتر جدول"
    },
    filter: {
      all: "همه",
      title: "فیلترها",
      reset: "بازنشانی"
    },
    viewColumns: {
      title: "نمایش ستون ها",
      titleAria: "نمایش/عدم نمایش ستون‌های جدول"
    },
    selectedRows: {
      text: "ردیف انتخاب شده",
      delete: "حذف",
      deleteAria: "حذف کردن این ردیف"
    }
  }
};
export const options = {
  filterType: "dropdown",
  download: false,
  print: false,
  selectableRows: "none"
  // filter: false,
  // viewColumns: false
};
